// lib/utils.ts
import { type ClassValue } from "clsx"
import clsx from "clsx"
import { twMerge } from "tailwind-merge"
export function cn(...inputs: ClassValue[]) { return twMerge(clsx(inputs)) }

// lib/utils.ts

// --- fechas seguras para listas/chat ---
export const toEpochMs = (value: unknown): number => {
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim()) {
    const t = Date.parse(value);
    return Number.isFinite(t) ? t : 0;
  }
  return 0; // fallback seguro
};

export const coalesceTime = (...vals: unknown[]): number => {
  for (const v of vals) {
    const t = toEpochMs(v);
    if (t > 0) return t;
  }
  return 0;
};
